// Google AdSense Configuration
export const ADSENSE_CONFIG = {
  // Client ID - use environment variable in development, hardcoded in production
  CLIENT_ID: import.meta.env.VITE_GOOGLE_ADSENSE_CLIENT_ID || 'ca-pub-3349161084383893',
  
  // Ad Slots configuration
  SLOTS: {
    // Header banner (728x90)
    HEADER: '1111111111',
    
    // Content ads (responsive)
    CONTENT: '2222222222',
    
    // Sidebar ads (300x250)
    SIDEBAR: '3333333333',
    
    // Footer banner (728x90)
    FOOTER: '4444444444',
    
    // Test slot for development
    TEST: '5555555555'
  },
  
  // Ad formats
  FORMATS: {
    BANNER: 'auto',
    CONTENT: 'fluid',
    SIDEBAR: 'auto',
    FOOTER: 'auto'
  },
  
  // Check if AdSense is properly configured
  isConfigured: function() {
    return !!this.CLIENT_ID && 
           this.CLIENT_ID !== 'ca-pub-xxxxxxxxxxxxxx' &&
           this.CLIENT_ID.startsWith('ca-pub-') &&
           this.CLIENT_ID === 'ca-pub-3349161084383893';
  },
  
  // Get slot ID by type
  getSlot: function(type: keyof typeof this.SLOTS) {
    return this.SLOTS[type];
  }
} as const;

export default ADSENSE_CONFIG; 